import Vue from 'vue'
import uiKitPlugin, { IdfIcon } from '@invivodf/ui-kit'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
import { localize } from 'vee-validate'
import { installCommonCustomValidateRules } from '@invivodf/common/src/infrastructure/rules/custom-common-rules.validate'
import { provideComposables } from '@invivodf/common/src/contexts/logistic-offer/application/composables/dependency-injection'
import dictionaryLast from '@/core/dictionaries'
import AxeptioPlugin from '@/plugins/axeptio.plugin'
import router from '@/router'
import installCustomValidateRules from '@/services/custom-rules.validate'
import store from '@/store'
import { bootstrapB2agAuth } from '@/auth/bootstrapAuth-b2ag'
import { registerCommonPlugins, mountApp } from './main-shared'

function registerB2agPlugins(): void {
  Vue.use(uiKitPlugin as any, {
    environmentName: window.env.ENVIRONMENT_NAME,
    cloudinaryBucketName: window.env.CLOUDINARY_BUCKET_NAME,
  })
  // IdfAccordion (ui-kit 0.200) rend <idf-icon> sans le déclarer dans ses `components`,
  // contrairement à IdfBreadcrumb, IdfInput ou IdfCollapse. L'enregistrement global du
  // plugin n'a lieu qu'avec `preloadAllComponents`, qu'on ne veut pas activer pour 45
  // composants. On enregistre donc la seule icône, sinon le chevron de l'accordéon ne
  // se rend pas du tout ("Unknown custom element: <idf-icon>").
  Vue.component(IdfIcon.name, IdfIcon)

  // Analytics
  if (!window.Cypress && window.env.AXEPTIO_CLIENT_ID) {
    Vue.use(AxeptioPlugin, {
      clientId: window.env?.AXEPTIO_CLIENT_ID,
      base: window.env?.AXEPTIO_BASE,
    })
  }
  Vue.use(VueAnalytics, {
    id: window.env.ANALYTICS_ID,
    disabled: !Vue.$axeptioPluginInstalled,
    router,
  })

  Vue.use(BootstrapVue)

  // vee-validate v3 — b2ag rules then the common ones (common wins on collision)
  localize(dictionaryLast)
  installCustomValidateRules()
  installCommonCustomValidateRules()
}

export async function startB2agApp(): Promise<void> {
  registerCommonPlugins()
  registerB2agPlugins()

  // @ts-expect-error : XJU à typer plus tard
  window.globalStore = store

  await bootstrapB2agAuth()
  mountApp({ store, provide: { ...provideComposables() } })
}
